import React from 'react';
import Icon from 'components/mweb/Icon/Icon';

const TRACKING_ORDER_PAYMENT = [
  {
    key: 'CART',
    icon: 'icon-cart-shipment-status',
    message: 'CART',
    status: 'done',
  },
  {
    key: 'SELECT_ADDRESS',
    icon: 'icon-location-marker-shipment',
    message: 'SELECT ADDRESS',
    status: 'done',
  },
  {
    key: 'SHIPMENT',
    icon: 'icon-shipment-bag',
    message: 'SHIPMENT',
    status: 'done',
  },
  {
    key: 'PAYMENT',
    icon: 'icon-payment-rupee',
    message: 'PAYMENT',
    status: 'inactive',
  },
];

const TRACKING_SUBSCRIPTION_PAYMENT = [
  {
    key: 'day-time',
    icon: 'icon-shipment-bag',
    message: 'SELECT DAY/TIME',
    status: 'done',
  },
  {
    key: 'PRODUCTS',
    icon: 'icon-cart-shipment-status',
    message: 'SELECT PRODUCTS',
    status: 'done',
  },
  {
    key: 'SELECT_ADDRESS',
    icon: 'icon-location-marker-shipment',
    message: 'SELECT ADDRESS',
    status: 'done',
  },
  {
    key: 'PAYMENT',
    icon: 'icon-payment-rupee',
    message: 'SUBSCRIBE & PAY',
    status: 'inactive',
  },
];

const ShipmentTracker = ({ type, source = '' }) => {
  const statusSet =
    source === 'subscription'
      ? TRACKING_SUBSCRIPTION_PAYMENT
      : TRACKING_ORDER_PAYMENT;
  return (
    <div className="desktop-shipment--status">
      {statusSet.map((status, index) => {
        const STATUS = status.key === type ? 'active' : status.status;
        return (
          <div className={`shipment-track ${STATUS}`} key={status.key}>
            <div className="shipment-track--icon">
              <Icon class={status.icon} size={30} />
            </div>
            <div className="shipment-track--timeline">
              <Icon
                class={`icon-status-order-${STATUS} flex-shrink-0`}
                size={15}
              />
              {index !== TRACKING_ORDER_PAYMENT.length - 1 && (
                <div className="shipment-track--timeline--border" />
              )}
            </div>
            <div className="shipment-track--message">
              <div>{status.message}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShipmentTracker;
